<template>
  <div class="app-main-inner app-main-page basic-data">
    <el-container class="app-main-inner-row">
      <el-aside
        class="inner-box"
        style="width:fit-content;height:calc(100vh - 210px);overflow-x: hidden;margin-top: 60px"
      >
        <el-radio-group v-model="currentBar" style="display: flex;flex-direction: column" no="navigationBars" @change="barChange">
          <el-radio
            v-for="(item,index) in navigationBars"
            :key="index"
            :label="item.value"
            style="line-height:30px;"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-aside>
      <el-main style="padding:0px;flex: 1">
        <continent v-if="currentBar === 'Continent'" ref="continent" no="continent" />
        <region v-if="currentBar === 'Region'" ref="region" no="region" />
        <msc-service v-if="currentBar === 'MscServiceCode'" ref="mscService" no="mscService" />
        <network v-if="currentBar === 'Network'" ref="network" no="network" />
        <currency v-if="currentBar === 'Currency'" ref="currency" no="currency" />
        <eq-type v-if="currentBar === 'EQType'" ref="eqType" no="eqType" />
        <packing v-if="currentBar === 'Packing'" ref="packing" no="packing" />
        <order-form-type v-if="currentBar === 'OrderFormType'" ref="orderFormType" no="orderFormType" />
        <cargo-type v-if="currentBar === 'CargoType'" ref="cargoType" no="cargoType" />
        <inco-term v-if="currentBar === 'IncoTerm'" ref="incoTerm" no="incoTerm" />
        <shipping-term v-if="currentBar === 'ShippingTerm'" ref="shippingTerm" no="shippingTerm" />
        <payment-term v-if="currentBar === 'PaymentTerm'" ref="paymentTerm" no="paymentTerm" />
        <trade-term v-if="currentBar === 'TradeTerm'" ref="tradeTerm" no="tradeTerm" />
        <gp-explain-title v-if="currentBar === 'GpExplainTitle'" ref="gpExplainTitle" no="gpExplainTitle" />
        <customs-mode v-if="currentBar === 'CustomsMode'" ref="customsMode" no="customsMode" />
        <price-air-service v-if="currentBar === 'PriceAirService'" ref="priceAirService" no="priceAirService" />
        <port-group v-if="currentBar === 'PortGroup'" ref="portGroup" no="portGroup" />
        <other-charge-item v-if="currentBar === 'OtherChargeItem'" ref="otherChargeItem" no="otherChargeItem" />
        <customer-type v-if="currentBar === 'CustomerType'" ref="customerType" no="customerType" />
        <appraisal-category v-if="currentBar === 'AppraisalCategory'" ref="appraisalCategory" no="appraisalCategory" />
        <bl-mode v-if="currentBar === 'BlMode'" ref="blMode" no="blMode" />
        <cutom-job-type v-if="currentBar === 'CutomJobType'" ref="cutomJobType" no="cutomJobType" />
        <transmit-file-type v-if="currentBar === 'TransmitFileType'" ref="transmitFileType" no="transmitFileType" />
        <commission-rule v-if="currentBar === 'CommissionRule'" ref="commissionRule" no="commissionRule" />
        <railway-line v-if="currentBar === 'RailwayLine'" ref="railwayLine" no="railwayLine" />
        <value-added-services v-if="currentBar === 'ValueAddedServices'" ref="valueAddedServices" no="valueAddedServices" />
        <charge-unit v-if="currentBar === 'ChargeUnit'" ref="chargeUnit" no="chargeUnit" />
        <dangerous-goods v-if="currentBar === 'DangerousGoods'" ref="dangerousGoods" no="dangerousGoods" />
        <cargo-information v-if="currentBar === 'CargoInformation'" ref="cargoInformation" no="cargoInformation" />
        <propulsion-type v-if="currentBar === 'PropulsionType'" ref="propulsionType" no="propulsionType" />
        <customer-source v-if="currentBar === 'CustomerSource'" ref="customerSource" no="customerSource" />
        <reason-for-judgment v-if="currentBar === 'ReasonForJudgment'" ref="reasonForJudgment" no="reasonForJudgment" />
        <transport-type v-if="currentBar === 'CTT'" ref="ctt" no="" />
        <vehicle-model v-if="currentBar === 'VehicleModel'" ref="vehicleModel" no="vehicleModel" />
        <cooperation-type v-if="currentBar === 'CooperationType'" ref="cooperationType" no="cooperationType" />
        <airplane-model v-if="currentBar === 'AirplaneModel'" ref="airplaneModel" no="airplaneModel" />
        <airplane-container v-if="currentBar === 'AirplaneContainer'" ref="airplaneContainer" no="airplaneContainer" />
        <custom-eq-type v-if="currentBar === 'CustomEqType'" ref="customEqType" no="customEqType" />
        <charge-group v-if="currentBar === 'ChargeGroup'" ref="chargeGroup" no="chargeGroup" />
        <customs-declaration-type v-if="currentBar === 'CustomsDeclarationType'" ref="customsDeclarationType" no="customsDeclarationType" />
        <air-cargo-terminal v-if="currentBar === 'AirCargoTerminal'" ref="airCargoTerminal" no="airCargoTerminal" />
        <general-cargo-warehouse v-if="currentBar === 'GeneralCargoWarehouse'" ref="generalCargoWarehouse" no="generalCargoWarehouse" />
        <warehouse-storage-location v-if="currentBar === 'WarehouseStorageLocation'" ref="warehouseStorageLocation" no="warehouseStorageLocation" />
        <pallet-configuration v-if="currentBar === 'PalletConfiguration'" ref="palletConfiguration" no="palletConfiguration" />
        <wooden-package-type v-if="currentBar === 'WoodenPackageType'" ref="woodenPackageType" no="woodenPackageType" />
        <statistic-area v-if="currentBar === 'StatisticArea'" ref="statisticArea" no="statisticArea" />
        <dangerous-good-package v-if="currentBar === 'DangerousGoodPackage'" ref="dangerousGoodPackage" no="dangerousGoodPackage" />
        <transport-source v-if="currentBar === 'TransportSource'" ref="transportSource" no="transportSource" />
        <transportation-type v-if="currentBar === 'TransportationType'" ref="transportationType" no="transportationType" />
        <payment-method v-if="currentBar === 'PaymentMethod'" ref="paymentMethod" no="paymentMethod" />
        <special-operation-code v-if="currentBar === 'SpecialOperationCode'" ref="specialOperationCode" no="specialOperationCode" />
        <transshipment-transportation-mode v-if="currentBar === 'TransshipmentTransportationMode'" ref="transshipmentTransportationMode" no="transshipmentTransportationMode" />
        <air-service-product v-if="currentBar === 'AirServiceProduct'" ref="airServiceProduct" no="airServiceProduct" />
        <commerce v-if="currentBar === 'Commerce'" ref="commerce" no="commerce" />
        <town v-if="currentBar === 'Town'" ref="town" no="town" />
        <postalCode v-if="currentBar === 'PostalCode'" ref="postalCode" no="postalCode" />
        <branch-fleet v-if="currentBar === 'BranchFleet'" ref="branchFleet" no="branchFleet" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import continent from './components/basicData/continent'
import region from './components/basicData/region'
import mscService from './components/basicData/mscService'
import network from './components/basicData/network'
import currency from './components/basicData/currency'
import eqType from './components/basicData/eqType'
import packing from './components/basicData/packing'
import orderFormType from './components/basicData/orderFormType'
import woodenPackageType from './components/basicData/woodenPackageType'
import statisticArea from './components/basicData/statisticArea'
import dangerousGoodPackage from './components/basicData/dangerousGoodPackage'
import cargoType from './components/basicData/cargoType'
import incoTerm from './components/basicData/incoTerm'
import airServiceProduct from './components/basicData/airServiceProduct'
import shippingTerm from './components/basicData/shippingTerm'
import paymentTerm from './components/basicData/paymentTerm'
import tradeTerm from './components/basicData/tradeTerm'
import priceAirService from './components/basicData/priceAirService'
import portGroup from './components/basicData/portGroup'
import otherChargeItem from './components/basicData/otherChargeItem'
import customerType from './components/basicData/customerType'
import blMode from './components/basicData/blMode'
import cutomJobType from './components/basicData/cutomJobType'
import AirCargoTerminal from './components/basicData/airCargoTerminal'
import GeneralCargoWarehouse from './components/basicData/generalCargoWarehouse'
import WarehouseStorageLocation from './components/basicData/warehouseStorageLocation'
import PalletConfiguration from './components/basicData/palletConfiguration'
import transmitFileType from './components/basicData/transmitFileType'
import commissionRule from './components/basicData/commissionRule'
import railwayLine from './components/basicData/railwayLine'
import chargeUnit from './components/basicData/chargeUnit'
import dangerousGoods from './components/basicData/dangerousGoods'
import cargoInformation from './components/basicData/cargoInformation'
import checkPermission from '@/utils/permission'
import { getUserInfo } from '@/utils/auth'
import PropulsionType from './components/basicData/propulsionType'
import customerSource from './components/basicData/customerSource'
import ReasonForJudgment from '@/views/cargo/v0/Information/components/basicData/reasonForJudgment'
import ValueAddedServices from '@/views/cargo/v0/Information/components/basicData/valueAddedServices'
import CustomsMode from '@/views/cargo/v0/Information/components/basicData/customsMode'
import TransportType from '@/views/cargo/v0/Information/components/basicData/transportType'
import VehicleModel from '@/views/cargo/v0/Information/components/basicData/vehicleModel'
import CooperationType from '@/views/cargo/v0/Information/components/basicData/cooperationType'
import AirplaneModel from '@/views/cargo/v0/Information/components/basicData/airplaneModel'
import AirplaneContainer from '@/views/cargo/v0/Information/components/basicData/airplaneContainer'
import CustomEqType from '@/views/cargo/v0/Information/components/basicData/customEqType'
import chargeGroup from './components/basicData/chargeGroup'
import customsDeclarationType from './components/basicData/customsDeclarationType'
import gpExplainTitle from './components/basicData/gpExplainTitle.vue'
import transportSource from './components/basicData/transportSource'
import TransportationType from '@/views/cargo/v0/Information/components/basicData/transportationType'
import PaymentMethod from '@/views/cargo/v0/Information/components/basicData/paymentMethod'
import SpecialOperationCode from '@/views/cargo/v0/Information/components/basicData/specialOperationCode'
import TransshipmentTransportationMode from '@/views/cargo/v0/Information/components/basicData/TransshipmentTransportationMode.vue'
import AppraisalCategory from '@/views/cargo/v0/Information/components/basicData/appraisalCategory.vue'
import Commerce from '@/views/cargo/v0/Information/components/basicData/commerce.vue'
import Town from '@/views/cargo/v0/Information/components/basicData/town.vue'
import PostalCode from '@/views/cargo/v0/Information/components/basicData/postalCode.vue'
import BranchFleet from '@/views/cargo/v0/Information/components/basicData/branchFleet.vue'

export default {
  name: 'BasicData',
  components: {
    PostalCode,
    Town,
    Commerce,
    AppraisalCategory,
    CustomEqType,
    AirplaneContainer,
    AirplaneModel,
    VehicleModel,
    TransportType,
    ValueAddedServices,
    CustomsMode,
    ReasonForJudgment, AirCargoTerminal, GeneralCargoWarehouse, WarehouseStorageLocation, PalletConfiguration,
    continent, region, mscService, network, currency, eqType, packing, orderFormType, cargoType,
    incoTerm, shippingTerm, paymentTerm, tradeTerm, priceAirService, portGroup, otherChargeItem,
    customerType, blMode, cutomJobType, transmitFileType, commissionRule, railwayLine, chargeUnit,
    dangerousGoods, cargoInformation, PropulsionType, customerSource, CooperationType, chargeGroup,
    customsDeclarationType, woodenPackageType, statisticArea, dangerousGoodPackage, gpExplainTitle, transportSource,
    TransportationType, PaymentMethod, SpecialOperationCode, TransshipmentTransportationMode,
    airServiceProduct, BranchFleet
  },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      navigationBars: [],
      currentBar: '',
      tenantId: ''
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    const isPlatform = this.tenantId === this.PLATFORM_TENANT_ID
    const bars = []
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.Continent'), englishLabel: 'Continent', value: 'Continent' })
    }
    bars.push({ label: this.$t('Information.ShippingRoute'), englishLabel: 'Region', value: 'Region' })
    bars.push({ label: this.$t('Information.MscService'), englishLabel: 'Msc Service Code', value: 'MscServiceCode' })
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.Network'), englishLabel: 'Network', value: 'Network' })
    }
    bars.push({ label: this.$t('Information.Currency'), englishLabel: 'Currency', value: 'Currency' })
    bars.push({ label: this.$t('Information.ContainerType'), englishLabel: 'EQ Type', value: 'EQType' })
    bars.push({ label: this.$t('Information.CustomEqType'), englishLabel: 'Custom eqType', value: 'CustomEqType' })
    bars.push({ label: this.$t('Information.Package'), englishLabel: 'Packing', value: 'Packing' })
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.BillOfLadingType'), englishLabel: 'Order Form Type', value: 'OrderFormType' })
    }
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.CargoType'), englishLabel: 'Cargo Type', value: 'CargoType' })
    }
    bars.push({ label: this.$t('Information.TradeTerms'), englishLabel: 'Trade terms', value: 'IncoTerm' })
    bars.push({ label: this.$t('Information.TransportationTerms'), englishLabel: 'Shipping Term', value: 'ShippingTerm' })
    bars.push({ label: this.$t('Information.FreightTerms'), englishLabel: 'Payment Term', value: 'PaymentTerm' })
    bars.push({ label: this.$t('Information.TradeMethod'), englishLabel: 'Trade Term', value: 'TradeTerm' })
    bars.push({ label: this.$t('Information.GpExplainTitle'), englishLabel: 'GP Explain Title', value: 'GpExplainTitle' })
    bars.push({ label: this.$t('Information.CustomsDeclarationMethod'), englishLabel: 'Customs Mode', value: 'CustomsMode' })
    bars.push({ label: this.$t('SeaExport.CustomsDeclarationType'), englishLabel: 'Customs Declaration Type', value: 'CustomsDeclarationType' })
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.AirFreightServiceItem'), englishLabel: 'Price Air Service', value: 'PriceAirService' })
    }
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.RelatedPort'), englishLabel: 'Port Group', value: 'PortGroup' })
    }
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.AirWaybillSundryCharge'), englishLabel: 'Other Charge Item', value: 'OtherChargeItem' })
    }
    if (!isPlatform) {
      bars.push({ label: this.$t('Information.ClientType'), englishLabel: 'Customer Type', value: 'CustomerType' })
    }
    bars.push({ label: this.$t('Information.AppraisalCategory'), englishLabel: 'appraisal category', value: 'AppraisalCategory' })
    bars.push({ label: this.$t('Information.ShippingDocumentMethod'), englishLabel: 'Bl Mode', value: 'BlMode' })
    bars.push({ label: this.$t('Information.CustomBusinessType'), englishLabel: 'Custom business type', value: 'CutomJobType' })
    bars.push({ label: this.$t('Information.TransitDocumentType'), englishLabel: 'Transmit File Type', value: 'TransmitFileType' })
    bars.push({ label: this.$t('Information.CommissionRule'), englishLabel: 'Commission Rule', value: 'CommissionRule' })
    bars.push({ label: this.$t('Information.RailwayLine'), englishLabel: 'Railway Line', value: 'RailwayLine' })
    bars.push({ label: this.$t('Information.ValueAddedService'), englishLabel: 'Value-added services', value: 'ValueAddedServices' })
    bars.push({ label: this.$t('Information.BilledUnitUnit'), englishLabel: 'Charge Unit', value: 'ChargeUnit' })
    bars.push({ label: this.$t('Information.HazardousGoods'), englishLabel: 'Dangerous Goods', value: 'DangerousGoods' })
    bars.push({ label: this.$t('Information.CargoInformation'), englishLabel: 'Cargo Information', value: 'CargoInformation' })
    bars.push({ label: this.$t('Information.PropulsionType'), englishLabel: 'Propulsion Type', value: 'PropulsionType' })
    bars.push({ label: this.$t('Information.LiabilityReason'), englishLabel: 'Reason For Judgment', value: 'ReasonForJudgment' })
    bars.push({ label: this.$t('Information.ClientSource'), englishLabel: 'Source Of Client', value: 'CustomerSource' })
    bars.push({ label: this.$t('Information.MultimodalTransportType'), englishLabel: 'Comprehensive transportation type', value: 'CTT' })
    bars.push({ label: this.$t('Information.VehicleType'), englishLabel: 'Vehicle model', value: 'VehicleModel' })
    bars.push({ label: this.$t('Information.CollaborativeBusinessType'), englishLabel: 'Cooperation Business Type', value: 'CooperationType' })
    bars.push({ label: this.$t('Information.AircraftModel'), englishLabel: 'Airplane Model', value: 'AirplaneModel' })
    bars.push({ label: this.$t('Information.UnitLoadDevice'), englishLabel: 'Airplane Container', value: 'AirplaneContainer' })
    bars.push({ label: this.$t('Information.ChargeGroup'), englishLabel: 'Charge Group', value: 'ChargeGroup' })
    bars.push({ label: this.$t('CargoMsg.Cargo_AirCargoTerminal'), englishLabel: 'Air cargo terminal', value: 'AirCargoTerminal' })
    bars.push({ label: this.$t('CargoMsg.Cargo_GeneralCargoWarehouse'), englishLabel: 'General Cargo Warehouse', value: 'GeneralCargoWarehouse' })
    bars.push({ label: this.$t('CargoMsg.Cargo_WarehouseStorageLocation'), englishLabel: 'Warehouse storage location', value: 'WarehouseStorageLocation' })
    bars.push({ label: this.$t('CargoMsg.Cargo_PalletConfiguration'), englishLabel: 'Pallet Configuration', value: 'PalletConfiguration' })
    bars.push({ label: this.$t('CargoMsg.Cargo_WoodenPackagingType'), englishLabel: 'Wooden packaging type', value: 'WoodenPackageType' })
    bars.push({ label: this.$t('CargoMsg.Cargo_ServiceStatisticalArea'), englishLabel: 'Statistic Area', value: 'StatisticArea' })
    bars.push({ label: this.$t('CargoMsg.Cargo_DangerousGoodPackage'), englishLabel: 'Dangerous Goods Packaging', value: 'DangerousGoodPackage' })
    bars.push({ label: this.$t('CargoMsg.Cargo_TransportSource'), englishLabel: 'Transport Source', value: 'TransportSource' })
    bars.push({ label: this.$t('CargoMsg.Cargo_TransportationType'), englishLabel: 'Transportation Type', value: 'TransportationType' })
    bars.push({ label: this.$t('CargoMsg.Cargo_PaymentMethod'), englishLabel: 'Payment Method', value: 'PaymentMethod' })
    bars.push({ label: this.$t('SeaExport.specialHandlingCodes'), englishLabel: 'Special Handling Codes', value: 'SpecialOperationCode' })
    if (isPlatform) {
      bars.push({ label: this.$t('SeaExport.TransshipmentTransportationMethod'), englishLabel: 'Transportation mode of transfer', value: 'TransshipmentTransportationMode' })
    }
    bars.push({ label: this.$t('CargoMsg.Cargo_AirServiceProduct'), englishLabel: 'Air Service Product', value: 'AirServiceProduct' })
    bars.push({ label: this.$t('CargoMsg.Cargo_BusinessManager'), englishLabel: 'Business Manager', value: 'Commerce' })
    bars.push({ label: this.$t('CargoMsg.Cargo_AdministrativeDivision'), englishLabel: 'Administrative Division', value: 'Town' })
    bars.push({ label: '支线车队', englishLabel: 'Branch Fleet', value: 'BranchFleet' })
    if (isPlatform) {
      bars.push({ label: this.$t('CargoMsg.Cargo_PostalCodeManagement'), englishLabel: 'Postal Code Management', value: 'PostalCode' })
    }
    if (!['zh', 'ja'].includes(this.$i18n.locale)) {
      bars.forEach(function(item) {
        item.label = item.englishLabel
      })
    }
    if (user.admin) {
      this.navigationBars = bars
    } else {
      this.navigationBars = bars.filter(p => checkPermission([`button_${p.value}_read`]))
    }
    if (this.tenantId === this.PLATFORM_TENANT_ID) {
      this.currentBar = 'Currency'
    } else {
      this.currentBar = 'Continent'
    }
  },
  mounted() {
    this.barChange()
  },
  methods: {
    barChange() {
      this.$nextTick(() => {
        switch (this.currentBar) {
          case 'Region':
            this.$refs.region.onShow()
            break
          case 'MscServiceCode':
            this.$refs.mscService.onShow()
            break
          case 'Network':
            this.$refs.network.onShow()
            break
          case 'Currency':
            this.$refs.currency.onShow()
            break
          case 'EQType':
            this.$refs.eqType.onShow()
            break
          case 'Packing':
            this.$refs.packing.onShow()
            break
          case 'OrderFormType':
            this.$refs.orderFormType.onShow()
            break
          case 'CargoType':
            this.$refs.cargoType.onShow()
            break
          case 'IncoTerm':
            this.$refs.incoTerm.onShow()
            break
          case 'ShippingTerm':
            this.$refs.shippingTerm.onShow()
            break
          case 'PaymentTerm':
            this.$refs.paymentTerm.onShow()
            break
          case 'TradeTerm':
            this.$refs.tradeTerm.onShow()
            break
          case 'CustomsMode':
            this.$refs.customsMode.onShow()
            break
          case 'PriceAirService':
            this.$refs.priceAirService.onShow()
            break
          case 'PortGroup':
            this.$refs.portGroup.onShow()
            break
          case 'OtherChargeItem':
            this.$refs.otherChargeItem.onShow()
            break
          case 'CustomerType':
            this.$refs.customerType.onShow()
            break
          case 'AppraisalCategory':
            this.$refs.appraisalCategory.onShow()
            break
          case 'BlMode':
            this.$refs.blMode.onShow()
            break
          case 'CutomJobType':
            this.$refs.cutomJobType.onShow()
            break
          case 'TransmitFileType':
            this.$refs.transmitFileType.onShow()
            break
          case 'CommissionRule':
            this.$refs.commissionRule.onShow()
            break
          case 'RailwayLine':
            this.$refs.railwayLine.onShow()
            break
          case 'ValueAddedServices':
            this.$refs.valueAddedServices.onShow()
            break
          case 'ChargeUnit':
            this.$refs.chargeUnit.onShow()
            break
          case 'DangerousGoods':
            this.$refs.dangerousGoods.onShow()
            break
          case 'CargoInformation':
            this.$refs.cargoInformation.onShow()
            break
          case 'PropulsionType':
            this.$refs.propulsionType.onShow()
            break
          case 'CustomerSource':
            this.$refs.customerSource.onShow()
            break
          case 'ReasonForJudgment':
            this.$refs.reasonForJudgment.onShow()
            break
          case 'CTT':
            this.$refs.ctt.onShow()
            break
          case 'VehicleModel':
            this.$refs.vehicleModel.onShow()
            break
          case 'CooperationType':
            this.$refs.cooperationType.onShow()
            break
          case 'AirplaneModel':
            this.$refs.airplaneModel.onShow()
            break
          case 'AirplaneContainer':
            this.$refs.airplaneContainer.onShow()
            break
          case 'CustomEqType':
            this.$refs.customEqType.onShow()
            break
          case 'ChargeGroup':
            this.$refs.chargeGroup.onShow()
            break
          case 'AirCargoTerminal':
            this.$refs.airCargoTerminal.onShow()
            break
          case 'GeneralCargoWarehouse':
            this.$refs.generalCargoWarehouse.onShow()
            break
          case 'WarehouseStorageLocation':
            this.$refs.warehouseStorageLocation.onShow()
            break
          case 'PalletConfiguration':
            this.$refs.palletConfiguration.onShow()
            break
          case 'WoodenPackageType':
            this.$refs.woodenPackageType.onShow()
            break
          case 'StatisticArea':
            this.$refs.statisticArea.onShow()
            break
          case 'DangerousGoodPackage':
            this.$refs.dangerousGoodPackage.onShow()
            break
          case 'CustomsDeclarationType':
            this.$refs.customsDeclarationType.onShow()
            break
          case 'GpExplainTitle':
            this.$refs.gpExplainTitle.onShow()
            break
          case 'TransportSource':
            this.$refs.transportSource.onShow()
            break
          case 'TransportationType':
            this.$refs.transportationType.onShow()
            break
          case 'PaymentMethod':
            this.$refs.paymentMethod.onShow()
            break
          case 'BranchFleet':
            this.$refs.branchFleet.onShow()
            break
          case 'SpecialOperationCode':
            this.$refs.specialOperationCode.onShow()
            break
          case 'TransshipmentTransportationMode':
            this.$refs.transshipmentTransportationMode.onShow()
            break
          case 'AirServiceProduct':
            this.$refs.airServiceProduct.onShow()
            break
          case 'Commerce':
            this.$refs.commerce.onShow()
            break
          case 'Town':
            this.$refs.town.onShow()
            break
          case 'PostalCode':
            this.$refs.postalCode.onShow()
            break
          default:
            break
        }
      })
    }
  }
}
</script>

<style lang="scss">
.basic-data {
  /*--滚动条样式 begin--*/
  .el-main{
    &>div{
      display: flex;
      flex-direction: column;
      height: 100%;
      .row-grid{
        flex-grow: 1;
      }
    }
  }
  .inner-box {
  }

  .inner-box::-webkit-scrollbar,
  .el-dialog__wrapper::-webkit-scrollbar {
    /*滚动条整体样式，宽高分别对应横竖滚动条的尺寸*/
    width: 6px;
    height: 6px;
  }

  .inner-box::-webkit-scrollbar-thumb,
  .el-dialog__wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 3px;
    background-color: #545557;
  }

  .inner-box::-webkit-scrollbar-track,
  .el-dialog__wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background-color: #dcdfe6;
  }

  /*--滚动条样式 end--*/
}
</style>
